// Три звука боя кодом (WebAudio, без файлов — бандл не растёт): удар, крит, победа (отчёт сравнения §6 п. 8).
// Звук включается жестом пользователя (первый тап по приёму), переключатель — в верхней строке боя (ux/04 §4.1).
import { storage } from '../state/storage.js';

let ctx: AudioContext | null = null;
export const soundOn = () => storage.get('sound') !== 'off' && sfxVolume() > 0;
export function setSound(on: boolean): void { storage.set('sound', on ? 'on' : 'off'); }
/** Громкость звуков 0–100 из настроек (ux/11 §2.1, по умолчанию 80). */
export function sfxVolume(): number { const v = Number(storage.get('sfxVolume') ?? 80); return Number.isFinite(v) ? Math.max(0, Math.min(100, v)) : 80; }

function ac(): AudioContext | null {
  if (!soundOn()) return null;
  try {
    ctx ??= new AudioContext();
    if (ctx.state === 'suspended') void ctx.resume();
    return ctx;
  } catch { return null; }
}

function tone(c: AudioContext, freq: number, at: number, dur: number, type: OscillatorType, vol: number, slideTo?: number) {
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, at);
  if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, at + dur);
  g.gain.setValueAtTime(Math.max(0.0011, vol * sfxVolume() / 80), at);
  g.gain.exponentialRampToValueAtTime(0.001, at + dur);
  o.connect(g).connect(c.destination);
  o.start(at);
  o.stop(at + dur + 0.02);
}

export type Sfx = 'hit' | 'crit' | 'win';

export function play(s: Sfx): void {
  const c = ac();
  if (!c) return;
  const t = c.currentTime;
  if (s === 'hit') { tone(c, 180, t, 0.12, 'square', 0.18, 60); }
  else if (s === 'crit') { tone(c, 220, t, 0.14, 'square', 0.22, 70); tone(c, 880, t + 0.05, 0.18, 'triangle', 0.12); }
  else { [523, 659, 784, 1047].forEach((f, i) => tone(c, f, t + i * 0.11, 0.22, 'triangle', 0.14)); }
}
